import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DetailsView from '../DetailsView';
import ContractInputs from './ContractInputs';
import { MODELS } from '../../../constants/admin/settings';
import * as actions from '../../../actions/admin/models/contracts';
import { canSubmit } from '../../../selectors/admin/forms';
import AdminModalForm from '../AdminModalForm';
import { onInput } from '../../../actions/admin/forms';
import {
    canSendContractReminderSelector,
    commentsSelector,
    formDataSelector,
    isLastVersionSelector
} from '../../../selectors/admin/models/contracts';
import { CONTRACT_STATE_DRAFT, CONTRACT_STATE_SENT, CONTRACT_STATE_SIGNED } from '../../../constants/settings';
import { openModalFormWithData } from '../../../actions/admin/modal.forms';
import ContractUploadFields from '../../../components/admin/forms/contracts/ContractUploadFields';
import { get } from 'lodash';
import { Snackbar } from '@material-ui/core';
import { templateFromContract } from '../../../actions/admin/models/templates';
import CommentsModalForm from '../../../components/admin/forms/contracts/CommentsModalForm';
import { sendContractReminder } from '../../../actions/admin/models/contracts';
import { downloadContract } from '../../../actions/admin/models/contracts';

class ContractsForm extends Component {
    state = {
        sendModalOpen: false,
        uploadModalOpen: false,
        reminderModalOpen: false,
        showCopyToast: false
    };
    _dropdown = () => {
        const state = get(this.props.data, 'version.state');
        return {
            options: ['SAVE AS DRAFT', 'USE AS TEMPLATE'].concat(
                this.props.data.id
                    ? ['UPLOAD CONTRACT', 'DOWNLOAD CONTRACT', this.props.data.archived ? 'UNARCHIVE' : 'ARCHIVE']
                    : [],
                this.props.data.publicId ? ['COPY PUBLIC LINK'] : [],
                this.props.canSendReminder ? ['SEND REMINDER'] : []
            ),
            functions: [
                this._saveAsDraft,
                this._useAsTemplate,
                this._openUploadForm,
                this._downloadContract,
                this._archiveUnArchive,
                this._copyPublicLinkToClipboard,
                ...(this.props.canSendReminder ? [this._openReminderModal] : [])
            ],
            disabled: [
                !this.props.canSubmit || state === CONTRACT_STATE_SIGNED,
                !this.props.canSubmit,
                state === CONTRACT_STATE_SIGNED,
                !this.props.canSubmit,
                !this.props.data.publicId
            ]
        };
    };

    _openUploadForm = () => {
        this.setState({ uploadModalOpen: true, reminderModalOpen: false });
        this.props.openModalFormWithData(MODELS.CONTRACT_UPLOAD, { file: '', comments: '', state: '' });
    };

    _useAsTemplate = () => {
        this.props.templateFromContract(this.props.data.data, this.props.data.type);
    };

    _uploadContract = uploadData => {
        this.setState({ uploadModalOpen: false });
        this.props.uploadContract(this.props.data.id, uploadData);
    };

    _archiveUnArchive = () => {
        this.props.archive(this.props.contractId, {
            artistId: this.props.data.artistId,
            organizationId: this.props.data.organizationId,
            eventId: this.props.data.eventId,
            archived: !this.props.data.archived
        });
    };

    _saveAsDraft = () => {
        this.props.saveNewVersion(
            this.props.contractId,
            { ...this.props.data, ...(this.props.type ? { type: this.props.type } : {}) },
            CONTRACT_STATE_DRAFT
        );
    };

    _sendContract = () => {
        this.props.saveNewVersion(
            this.props.contractId,
            { ...this.props.data, ...(this.props.type ? { type: this.props.type } : {}) },
            CONTRACT_STATE_SENT
        );
    };

    _copyPublicLinkToClipboard = () => {
        // const publicUrl = `${window.location.origin}/review/${this.props.data.publicId}`;
        // copyTextToClipboard(publicUrl).then(() => {return this._handleOpenToast()});
        return this._handleOpenToast();
    };

    _handleCloseToast = () => {
        this.setState({ showCopyToast: false });
    };

    _handleOpenToast = () => {
        this.setState({ showCopyToast: true });
    };

    _openReminderModal = () => {
        this.setState({ reminderModalOpen: true, uploadModalOpen: false });
        this.props.openModalFormWithData(MODELS.CONTRACT_REMINDER, { comments: '' });
    };

    _downloadContract = () => {
        this.props.downloadContract(this.props.data.id, get(this.props.data, 'version.id'));
    };

    render() {
        return (
            <React.Fragment>
                <Snackbar
                    className="ckp-snackbar ckp-snackbar--top"
                    open={this.state.showCopyToast}
                    autoHideDuration={3000}
                    onClose={this._handleCloseToast}
                    message="Public link copied to clipboard."
                    anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
                />
                {this.state.uploadModalOpen && (
                    <AdminModalForm
                        title="Upload contract version"
                        fields={ContractUploadFields}
                        onClose={() => this.setState({ uploadModalOpen: false })}
                        model={MODELS.CONTRACT_UPLOAD}
                        createAction={this._uploadContract}
                        confirmLabel="Upload"
                    />
                )}
                {this.state.reminderModalOpen && (
                    <AdminModalForm
                        title="Send contract reminder"
                        fields={CommentsModalForm}
                        onClose={() => this.setState({ reminderModalOpen: false })}
                        model={MODELS.CONTRACT_REMINDER}
                        createAction={this.props.sendContractReminder}
                        createLabel="Send"
                    />
                )}
                <DetailsView
                    forceEdited={true}
                    fetchDependencies={this.props.fetchContractDependencies}
                    model={MODELS.CONTRACT}
                    fetchModel={this.props.fetchMember}
                    modelId={this.props.contractId}
                    editView={ContractInputs}
                    updateAction={this.props.update}
                    createAction={this.props.create}
                    dropdown={this._dropdown()}
                    submitAction={this._sendContract}
                    type={this.props.type}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, props) => ({
    data: formDataSelector(state),
    comments: commentsSelector(state),
    canSubmit: canSubmit(state, { model: MODELS.CONTRACT, subModel: MODELS.CONTRACT_DRAFT, modelId: props.contractId }),
    isLastVersion: isLastVersionSelector(state),
    canSendReminder: canSendContractReminderSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        { ...actions, openModalFormWithData, onInput, templateFromContract, sendContractReminder, downloadContract },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractsForm);
